import {css, useTheme} from "@emotion/react";

import {Badge} from "@pg-design/badge-module";
import {elevation} from "@pg-design/elevation";
import {borderRadius, calculateRemSize as crs, mr, p} from "@pg-design/helpers-css";
import {BrandLaurelIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {getThemeBreakpoint} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {useResponsiveLinkTarget} from "../../../../hooks/use_responsive_link_target";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IOfferDetail} from "../../../../offer/types/IOfferDetail";
import {rankingBigViewBreakpoint} from "../../../constants/ranking_big_view_breakpoint";
import {RankingOfferData} from "../../RankingOfferData";

interface IProps {
    offer: Pick<IOfferDetail, "name" | "main_image" | "street_name" | "street_number" | "region" | "vendor" | "slug" | "id" | "groups">;
    onItemClick?: () => void;
}

export function OfferRankingListItem(props: IProps) {
    const {offer} = props;
    const {name, main_image} = offer;
    const theme = useTheme();

    const target = useResponsiveLinkTarget();
    const offerLink = useOfferLink(offer);

    return (
        <li css={listItem} onClick={props.onItemClick}>
            <Badge
                as="span"
                icon={({fill, className}) => (
                    <BrandLaurelIcon css={[className, mr(1)]} fill={fill} wrapperColor={theme.colors.primary} wrapperSize="1.6" size="1.6" />
                )}
                css={badge}
            >
                <Text variant="info_txt_2" css={badgeText}>
                    Wyróżnienie
                </Text>
            </Badge>
            <a href={offerLink} target={target}>
                <Image width="336" height="180" alt={name} src={main_image.m_img_440x440} imageStyle={{objectFit: "cover"}} />
            </a>
            <div css={itemContent}>
                <RankingOfferData offer={offer} css={offerData} />
            </div>
        </li>
    );
}

// Styles
const listItem = css`
    max-width: 360px;
    width: 100%;
    ${borderRadius(2)};
    background: white;
    display: flex;
    flex-direction: column;
    ${elevation(1)};
    overflow: hidden;
    position: relative;

    @media screen and (min-width: ${rankingBigViewBreakpoint}) {
        max-width: none;
        flex-direction: row;
        width: 936px;
    }
`;

const badgeText = css`
    font-weight: 600;
`;

const badge = css`
    position: absolute;
    inset: ${crs(1)} auto auto ${crs(1)};
    z-index: 1;
`;

const itemContent = css`
    ${p(2)};
    gap: ${crs(2)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        flex: 1;
        display: flex;
        flex-direction: column;
    }
`;

const offerData = css`
    @media (min-width: ${getThemeBreakpoint().md}) {
        flex: 1;
    }
`;
import {css, useTheme} from "@emotion/react";

import {Badge} from "@pg-design/badge-module";
import {elevation} from "@pg-design/elevation";
import {borderRadius, calculateRemSize as crs, mr, p} from "@pg-design/helpers-css";
import {BrandLaurelIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {getThemeBreakpoint} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {useResponsiveLinkTarget} from "../../../../hooks/use_responsive_link_target";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IOfferDetail} from "../../../../offer/types/IOfferDetail";
import {rankingBigViewBreakpoint} from "../../../constants/ranking_big_view_breakpoint";
import {RankingOfferData} from "../../RankingOfferData";

interface IProps {
    offer: Pick<IOfferDetail, "name" | "main_image" | "street_name" | "street_number" | "region" | "vendor" | "slug" | "id" | "groups">;
    onItemClick?: () => void;
}

export function OfferRankingListItem(props: IProps) {
    const {offer} = props;
    const {name, main_image} = offer;
    const theme = useTheme();

    const target = useResponsiveLinkTarget();
    const offerLink = useOfferLink(offer);

    return (
        <li css={listItem} onClick={props.onItemClick}>
            <Badge
                as="span"
                icon={({fill, className}) => (
                    <BrandLaurelIcon css={[className, mr(1)]} fill={fill} wrapperColor={theme.colors.primary} wrapperSize="1.6" size="1.6" />
                )}
                css={badge}
            >
                <Text variant="info_txt_2" css={badgeText}>
                    Wyróżnienie
                </Text>
            </Badge>
            <a href={offerLink} target={target}>
                <Image width="336" height="180" alt={name} src={main_image.m_img_440x440} imageStyle={{objectFit: "cover"}} />
            </a>
            <div css={itemContent}>
                <RankingOfferData offer={offer} css={offerData} />
            </div>
        </li>
    );
}

// Styles
const listItem = css`
    max-width: 360px;
    width: 100%;
    ${borderRadius(2)};
    background: white;
    display: flex;
    flex-direction: column;
    ${elevation(1)};
    overflow: hidden;
    position: relative;

    @media screen and (min-width: ${rankingBigViewBreakpoint}) {
        max-width: none;
        flex-direction: row;
        width: 936px;
    }
`;

const badgeText = css`
    font-weight: 600;
`;

const badge = css`
    position: absolute;
    inset: ${crs(1)} auto auto ${crs(1)};
    z-index: 1;
`;

const itemContent = css`
    ${p(2)};
    gap: ${crs(2)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        flex: 1;
        display: flex;
        flex-direction: column;
    }
`;

const offerData = css`
    @media (min-width: ${getThemeBreakpoint().md}) {
        flex: 1;
    }
`;
